// Set per environment via .env.development / .env.production (CRA injects at build time).
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

export const PORTAL_NAME = 'Conference Direct'
export const SUPPORT_EMAIL = 'support@conferencedirect.com'

// Flip to true after replacing TermsContent.js with the client copy and
// running sql/migrations/010_terms_accepted.sql.
export const TERMS_GATE_ENABLED = false;
